/**
 * Dark mode semantic color tokens — Instagram dark theme.
 */
const darkTokens = {
  "bg-app":        { default: "#000000" },
  "bg-surface":    { default: "#121212" },
  "bg-elevated":   { default: "#1C1C1C" },
  "bg-input":      { default: "#262626" },
  "border-subtle": { default: "#262626" },
  "border-strong": { default: "#363636" },
  "text-primary":  { default: "#F5F5F5" },
  "text-secondary":{ default: "#A8A8A8" },
  "text-disabled": { default: "#555555" },
  "accent":        { default: "#E1306C" },
  "accent-hover":  { default: "#C1275C" },
  "bubble-sent":   { default: "#262626" },
  "bubble-received":{ default: "#1C1C1C" },
  "online":        { default: "#22C55E" },
};

export default darkTokens;
